import React from 'react';
import styled from 'styled-components';
import logo from '../../../assets/images/logo.svg';
import heroImage from '../../../assets/images/header.svg';
import Button from '../../shared/Button';
import Container from '../../shared/Container';
import Heading from '../../shared/Heading';
import Image from '../../shared/Image';
import FlexContent from '../../shared/FlexContent';
import StyledLink from '../../shared/StyledLink';

const HeaderDiv = styled.div`
  position: relative;
  color: white;
  ${StyledLink} {
    &:first-of-type {
      margin-right: 35px;
    }
  }
  @media (max-width: 1000px) {
    ${StyledLink} {
      position: absolute;
      top: 80px;
      right: 0;
      padding: 10px 20px;
    }
  }
`;

const Logo = styled.img`
  width: 60px;
  margin: 80px 0 0 0;
`;

const TextContainer = styled.div`
  align-self: start;
  margin-top: 80px;
  p {
    line-height: 1.5;
    max-width: 650px;
    margin-bottom: 50px;
    font-family: 'gothambook', serif;
    @media (max-width: 1000px) {
      max-width: initial;
    }
    @media (max-width: 1000px) {
      max-width: initial;
      text-align: center;
    }
  }
  @media (max-width: 1000px) {
    margin-top: 60px;
  }
`;

const Header = () => (
  <Container>
    <HeaderDiv>
      <Logo src={logo} alt="Site Logo" className="image" />
      <FlexContent>
        <TextContainer>
          <Heading>
            Diversifying <br /> Homes and Living
          </Heading>
          <p>
            We at ZOI Homes aim to make people more humane by building a
            vibrant, diverse, and accepting community while solving real state,
            renting and housing problems, especially for girls and people from
            the LGBTQ community, providing you the best possible living
            experience.
          </p>
          <StyledLink href="#takeatour" hideOnMobile>
            Take A Tour
          </StyledLink>
          <StyledLink href="#contact">Contact Us</StyledLink>
        </TextContainer>
        <Image>
          <img src={heroImage} alt="Hero" />
        </Image>
      </FlexContent>
    </HeaderDiv>
  </Container>
);

export default Header;
